import t from './SupportingDocument.type';

const initlialState = {
  supportingDocs: [],
  mergedUrl: '',
};

const SupportingDocument = (state = initlialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case t.FETCH_SUPPORTING_DOCS:
      return {
        ...state,
        supportingDocs: payload,
      };
    case t.DELETE_SUPPORTING_DOCS:
      let list = [...state.supportingDocs];
      list = list.filter((item) => !payload.includes(item._id));
      return {
        ...state,
        supportingDocs: list,
      };
    case t.UNMOUNT_SUPPORTING_DOCS:
      return {
        ...state,
        supportingDocs: [],
      };
    case t.FETCH_MERGED_DOCS:
      return {
        ...state,
        mergedUrl: payload,
      };
    case t.DELETE_MERGED_DOCS:
      return {
        ...state,
        mergedUrl: '',
      };
    default:
      return state;
  }
};

export default SupportingDocument;
